{
    "author_s_insight": "Avis de <0>{{name}}<\/0> :",
    "curated_by": "Géré par",
    "popular_tags": "Tags populaires",
    "powered_by": "Généré par",
    "studio_autodetect_browser_based": "Détection automatique (basée sur le navigateur)",
    "studio_block_background_color": "Couleur d’arrière-plan des blocs\n",
    "studio_border": "Contours",
    "studio_click_to_set": "Modifier",
    "studio_click_to_set_border": "Modifier",
    "studio_click_to_set_color": "Modifier",
    "studio_code_copied": "Code copié !",
    "studio_copy_code_to_clipboard": "Copier le code",
    "studio_curator_insight_background_color": "Couleur d'arrière-plan de l'avis du curateur",
    "studio_display_image_instead_of_media_video_embed": "Afficher l'image au lieu du média (vidéo, intégration)",
    "studio_display_powered_by_scoop_it": "Afficher \"Généré par Scoop.it\"",
    "studio_display_shadows": "Afficher des ombres",
    "studio_embed_widget_type": "Type de widget",
    "studio_filter_by_tag": "Filtrer par tag",
    "studio_language": "Langue",
    "studio_links_color": "Couleur des liens",
    "studio_maximum_number_of_columns": "Nombre maximal de colonnes",
    "studio_maximum_number_of_posts": "Nombre maximum de publications",
    "studio_minimum_number_of_columns": "Nombre minimal de colonnes",
    "studio_post_section_content": "Contenu",
    "studio_post_section_insight": "Avis du curateur",
    "studio_post_section_media": "Médias (image, vidéo)",
    "studio_post_section_meta": "Site et date",
    "studio_post_section_title": "Titre",
    "studio_posts_sections": "Sections",
    "studio_prevent_close": "Êtes-vous sûr de vouloir quitter cette page ? Aucune de vos modifications ne sera conservée.",
    "studio_remove_border": "Supprimer le contour",
    "studio_remove_color": "Supprimer la couleur",
    "studio_reset": "Réinitialiser",
    "studio_responsive_split_width": "Largeur de division responsive",
    "studio_show_header": "Afficher l’en-tête",
    "studio_show_paginator": "Afficher la pagination",
    "studio_show_tags": "Afficher le nuage de tag",
    "studio_style_expl": "<p> Si aucune couleur n'est définie, les couleurs par défaut de la page cible seront appliquées (par exemple, la couleur des liens sera la même que la couleurs des lien de la page dans laquelle sera insérée l'intégration.). <\/p> <p>Par défaut, les couleurs d'arrière plan sont transparentes.<\/p>",
    "studio_tag_cloud_max_tag_count": "Nombre maximum de tags",
    "studio_tag_cloud_title": "Titre du nuage de tags",
    "studio_title_embed_code": "Code d’intégration",
    "studio_title_page": "Page",
    "studio_title_posts": "Publications",
    "studio_title_preview_your_embed": "Aperçu de votre intégration",
    "studio_title_responsive_configuration": "Configuration \"responsive\"",
    "studio_title_styling": "Style",
    "studio_type_carousel": "Carrousel",
    "studio_type_minimalist_list": "Liste minimaliste",
    "studio_type_responsive_grid": "Grille responsive",
    "studio_use_publication_date": "Afficher la date de publication au lieu de la date de curation"
}